import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';

export default class ZoneModal extends Component {
    render() {
        return (
            <Modal
                show={this.props.show}
                bsSize="large"
                aria-labelledby="contained-modal-title-lg"
                onHide={() => this.props.onHide(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-lg">
                        <FormattedMessage id="modal-store-title" defaultMessage="Alert" />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        <FormattedMessage id="modal-zone-text1" defaultMessage="default" />
                        {'. '}
                        <FormattedMessage id="modal-zone-text2" defaultMessage="" />
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => this.props.onHide(true)}>
                        <FormattedMessage id="modal-store-button-empty" defaultMessage="Empty" />
                    </Button>
                    <Button onClick={() => this.props.onHide(false)}>
                        <FormattedMessage id="modal-store-button-close" defaultMessage="Cancel" />
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/zone/zone-modal.jsx
 **/